import config from "./EnvConfigs";
export const appInsightsKey = config.APPINSIGHTS_KEY;